import { FC, useState, useEffect } from "react";
import { Data, UserData, Spv } from "../../../types/org.type";
import { useStyles } from "./InfoDocWallex.styles";
import { File as FileEnum } from "@funded-here-interface/common/src/constant/enum";
import { toast } from "react-toastify";
import useGetDocument from "@funded-here-interface/common/src/hooks/useGetDocument";
import { useSelector } from "react-redux";
import { RootState } from "@funded-here-interface/admin-fundedhere/src/store";
import { downloadFile } from "@funded-here-interface/common/src/Utils/file";
import { FileType } from "@funded-here-interface/common/src/constant/enum";
import { useLocation } from "react-router-dom";
import { Modal, Button, Loader, LoadingOverlay } from "@mantine/core";
import { Divider, Text, Card, Group, Flex } from "@mantine/core";
import { IconCircleCheck, IconExclamationCircle } from "@tabler/icons-react";
import {
  codeToCountryNameMap,
  countryCodeAndCurrency,
  countryNameToCodeMap,
} from "@funded-here-interface/common/src/constant/country";
import { mapCountryToCurrencyCode } from "./Components/currencyCode";
import { ScreeningStatus } from "./Components/Enum";
import {
  mapCategoryToDocumentType,
  formatLocalDate,
  deduplicateCountries,
  getNameFromPath,
  getLocalPhotoIdentifier,
} from "./Components/utils";
import {
  checkWallexStatus,
  wallexInfoUpload,
  uploadWallexDocuments,
} from "./Service/ApiServices";
import Forms from "./Components/Forms";
import {
  mapEntityType,
  mapIndustryToBusinessType,
  mapIndustryToEmploymentIndustry,
} from "./data-mapping";
import { convertDate } from "@funded-here-interface/common/src/Utils/date";
import useGetRegtankOnboardingDetail from "../../../hooks/useGetRegtankOnboardingDetail";
import { splitPhoneNumber } from "../../../Utils/phoneUtils";
import { DocumentRenderer } from "./utils/documentRenderer";
import { documentConfigs, getDocumentHeader } from "./documentConfig";

interface IProps {
  userData: UserData | undefined;
  user: UserData[] | undefined;
  data: Data | undefined;
  spv: Spv | undefined;
}

interface RegtankPassportPhoto {
  userId?: number;
  requestId: string;
  frontDocumentPhoto: string;
  backDocumentPhoto: string;
  expiredDate: string;
}

const InfoDocWallex: FC<IProps> = ({ userData, data, user }) => {
  //For PopUp message
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | any>(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const { classes } = useStyles();
  const location = useLocation();
  const isOrgRoute =
    location.pathname.includes("/org-") || location.pathname.includes("/org/");
  const isIndividualRoute =
    location.pathname.includes("/individual-") ||
    location.pathname.includes("/individual/");
  const [screeningStatus, setScreeningStatus] = useState<string | null>(null);
  const [screeningRemarks, setScreeningRemarks] = useState<string | null>(null);
  const [localPassportPhotos, setLocalPassportPhotos] = useState<
    Record<
      string,
      Array<{
        file: File;
        previewUrl: string;
        binaryData?: ArrayBuffer;
      }>
    >
  >({});
  const [hasBeenSentToWallex, setHasBeenSentToWallex] =
    useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const userId = userData?.id;
  const [wallexPassportPhotos, setWallexPassportPhotos] = useState<
    Record<string, { ownerId: string; data: string; passportUserId?: string }>
  >({});
  const [uploadPartialSuccess, setUploadPartialSuccess] = useState(false);
  const [failedDocuments, setFailedDocuments] = useState<any[]>([]);
  const useGetDocumentMutaiton = useGetDocument();
  const [excludedFiles, setExcludedFiles] = useState<string[]>([]);
  const [lastUploadTimestamp, setLastUploadTimestamp] = useState<string | null>(
    null
  );
  // Initialize document paths from data for all configured document types
  const [documentPaths, setDocumentPaths] = useState(() => {
    const paths: Record<string, string[]> = {};
    documentConfigs.forEach(config => {
      paths[config.field] = data?.documentsUpload?.[config.field] || [];
    });
    return paths;
  });
  const getRegtankOnboardingDetailMutation = useGetRegtankOnboardingDetail();
  const [regtankDocumentPhoto, setRegtankDocumentPhoto] = useState<
    RegtankPassportPhoto[]
  >([]);
  const [passportPhotoIsLoading, setPassportPhotoIsLoading] = useState(false);

  useEffect(() => {
    let requestIds = [];
    if (user && user.length > 0) {
      for (const data of user) {
        if (data.regtankRequest && data.regtankRequest?.length > 0)
          requestIds.push(data.regtankRequest?.[0].requestId);
      }
    }
    const cachedDocumentPhotoRaw = sessionStorage.getItem(
      "regtankDocumentPhotos"
    );
    const cached = cachedDocumentPhotoRaw
      ? JSON.parse(cachedDocumentPhotoRaw)
      : {};
    const expired = requestIds.filter((x) => {
      const item = cached[x];
      if (!item) {
        sessionStorage.removeItem("regtankDocumentPhotos");
        return true;
      }
      return new Date(item.expiredAt) <= new Date();
    });
    setRegtankDocumentPhoto(Object.values(cached));
    if (expired.length > 0 && !hasBeenSentToWallex) {
      setPassportPhotoIsLoading(true);
      getRegtankOnboardingDetailMutation.mutate(
        { token, requestIds },
        {
          onSuccess: async (data) => {
            const updatedStorage = { ...cached };
            let regtankDocument: RegtankPassportPhoto[] = [];
            for (const detail of data) {
              const matchUser = user?.find(
                (x) =>
                  x.regtankRequest &&
                  x.regtankRequest.length > 0 &&
                  x.regtankRequest?.[0].requestId === detail.requestId
              );
              regtankDocument.push({
                userId: matchUser?.id,
                requestId: detail.requestId,
                frontDocumentPhoto: detail.frontDocumentPhoto,
                backDocumentPhoto: detail.backDocumentPhoto,
                expiredDate: detail.expiredAt,
              });
              updatedStorage[detail.requestId] = {
                userId: matchUser?.id,
                requestId: detail.requestId,
                frontDocumentPhoto: detail.frontDocumentPhoto,
                backDocumentPhoto: detail.backDocumentPhoto,
                expiredDate: detail.expiredAt,
              };
            }
            setRegtankDocumentPhoto(regtankDocument);
            setPassportPhotoIsLoading(false);
            sessionStorage.setItem(
              "regtankDocumentPhotos",
              JSON.stringify(updatedStorage)
            );
          },
          onError: (e) => {
            toast.error((e as Error).message);
          },
        }
      );
    }
  }, []);

  useEffect(() => {
    setDocumentPaths({
      businessProfile: data?.documentsUpload?.businessProfile || [],
      shareHoldersDirectorsRegisters:
        data?.documentsUpload?.shareHoldersDirectorsRegisters || [],
      proofOfAddress: data?.documentsUpload?.proofOfAddress || [],
    });
  }, [data]);

  // useEffect to check if the user documents has been sent to Wallex
  useEffect(() => {
    const checkDocAndWallexStatus = async () => {
      if (!userId) return;

      try {
        const response = await checkWallexStatus(userId, token);

        //Set excluded files if there are any
        if (response.excludedFiles?.length !== 0) {
          setExcludedFiles(response.excludedFiles ?? []);
        }
        // First check the screening status
        if (response.screeningStatus) {
          setScreeningStatus(response.screeningStatus);

          // Check if the status is in the list of successful states
          if (
            Object.values(ScreeningStatus).includes(
              response.screeningStatus as ScreeningStatus
            )
          ) {
            setHasBeenSentToWallex(true);
            setUploadPartialSuccess(false);
          } else if (
            response.screeningStatus === ScreeningStatus.DOCNEEDRESUBMISSION
          ) {
            setHasBeenSentToWallex(false);
            setUploadPartialSuccess(true);
          }
        }

        // Then check for current failed documents
        else if (
          (response.failedUploads && response.failedUploads > 0) ||
          (response.failedDocuments && response.failedDocuments.length > 0)
        ) {
          setHasBeenSentToWallex(true);
          setUploadPartialSuccess(true);

          // Handle both cases: direct uploads and refresh response
          if (response.failedDocuments) {
            setFailedDocuments(response.failedDocuments);
          } else if (response.results) {
            const failed = response.results
              .filter((item) => item.status === "error")
              .map((item) => ({ fileName: item.fileName }));

            setFailedDocuments(failed);
          }
        } else {
          setHasBeenSentToWallex(true);
          setUploadPartialSuccess(false);
        }

        // Update uploaded files
        if (Array.isArray(response.uploadedDocuments)) {
          setUploadedFiles(response.uploadedDocuments);
        }

        // Update passport photos
        if (response.passportPhotos) {
          setWallexPassportPhotos(response.passportPhotos);

          // Auto-exclude already uploaded passport photos
          const newExcludedFiles = [...excludedFiles];

          // Process each uploaded photo
          Object.entries(response.passportPhotos).forEach(([key, photo]) => {
            const typedPhoto = photo as { ownerId: string; data: string };
            const userIdFromPhoto = typedPhoto.ownerId;

            const matchingUser = user?.find(
              (u) => u.id.toString() === userIdFromPhoto
            );

            if (matchingUser?.didPassportPhoto) {
              const uniqueIdentifier = `user_${userIdFromPhoto}_photo_${matchingUser.didPassportPhoto}`;

              if (!newExcludedFiles.includes(uniqueIdentifier)) {
                newExcludedFiles.push(uniqueIdentifier);
              }
            }
          });

          if (newExcludedFiles.length > excludedFiles.length) {
            setExcludedFiles(newExcludedFiles);
          }
        }

        // Update screening remarks
        if (response.screeningRemarks) {
          setScreeningRemarks(response.screeningRemarks);
        }

        // Update last upload timestamp
        if (response.registrationDate) {
          setLastUploadTimestamp(response.registrationDate);
        }

        if (response.uploadStatus === "Success") {
          setHasBeenSentToWallex(true);
        }
      } catch (error) {
        console.error("Error checking Wallex status:", error);
      }
    };

    // Call immediately
    checkDocAndWallexStatus();

    // Also set up to check when window regains focus
    const handleFocus = () => {
      checkDocAndWallexStatus();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [userId]); // Update dependencies to include token

  // Function to handle local passport photos
  const handlePassportPhotoUpload = (
    userId: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // Process all selected files
    Array.from(files).forEach((file) => {
      // Create a preview URL for display only
      const previewUrl = URL.createObjectURL(file);

      const reader = new FileReader();
      reader.onload = () => {
        // Store the file, preview URL, and binary data
        // Only use the result if it's an ArrayBuffer
        setLocalPassportPhotos((prev) => ({
          ...prev,
          [userId]: [
            ...(prev[userId] || []),
            {
              file,
              previewUrl,
              binaryData:
                reader.result instanceof ArrayBuffer ? reader.result : undefined,
            },
          ],
        }));
      };

      // Read the file as an ArrayBuffer (binary data)
      reader.readAsArrayBuffer(file);
    });

    // Reset the file input so the same file can be selected again
    event.target.value = "";
  };

  //Setting country of residence
  const countryOfResidence: string =
    codeToCountryNameMap.get(data?.countryISOCode || "") || "-";

  //individual
  const firstName = isOrgRoute ? "Guofeng" : userData?.firstName || "-";
  const lastName = isOrgRoute ? "Chang" : userData?.lastName || "-";
  const email = isOrgRoute
    ? "guofeng.chang@fundedhere.com"
    : userData?.email || "-";
  const gender = isOrgRoute ? "male" : data?.gender.toLocaleLowerCase() || "-";

  // Split phone number for both org and individual routes
  const phoneData = splitPhoneNumber(
    isOrgRoute
      ? "+60177199872" // Temporary hardcoded value for org route
      : data?.companyPhoneNumber
  );
  const mobileCountryCode = phoneData.countryCode;
  const mobileNumber = phoneData.number;
  const employmentStatus = isOrgRoute
    ? "Employed"
    : data?.employmentStatus || "-";
  const employmentIndustry = isOrgRoute
    ? "Banking/Finance/Insurance"
    : mapIndustryToEmploymentIndustry(data?.industry) || "-";
  const employmentPosition = isOrgRoute
    ? "Senior Level/Executive"
    : data?.employmentPosition || "-";
  const dateOfBirth = isOrgRoute
    ? "03-01-1994"
    : convertDate(String(data?.dateOfBirth), "DD-MM-YYYY") || "-";

  const countryOfBirth = (() => {
    // For institution/organization
    if (isOrgRoute) {
      return "MY"; // Default for organizations
    }

    // For individuals
    if (data?.countryOfBirth) {
      // If countryOfBirth exists and it's in the mapping, use its ISO code
      if (
        typeof data.countryOfBirth === "string" &&
        data.countryOfBirth in countryCodeAndCurrency
      ) {
        return countryNameToCodeMap.get(data.countryOfBirth) || "-";
      }
      // Special case handling for common values
      if (data.countryOfBirth === "Singapore") return "SG";
      if (data.countryOfBirth === "Malaysia") return "MY";
    }
    return "-"; // Default fallback
  })();
  const address = isOrgRoute
    ? "No. 43, Jalan Intan Baiduri 3D, Taman Intan Baiduri, Kuala Lumpur"
    : data?.legalEntityAddress || "-";
  const postalCode = isOrgRoute ? "52100" : data?.postalCode || "-";
  const countryCode = (() => {
    // For institution/organization
    if (isIndividualRoute) {
      // If spv.countryOfIncorporation exists and it's in the mapping, use its ISO code
      if (
        countryOfResidence &&
        typeof countryOfResidence === "string" &&
        countryOfResidence in countryCodeAndCurrency
      ) {
        return countryNameToCodeMap.get(countryOfResidence) || "-";
      }
      return "-"; // Default fallback
    }

    return "MY"; // Default fallback for organizations
  })();
  const nationality = (() => {
    // For individual users
    if (isIndividualRoute) {
      if (data?.nationality) {
        // If nationality exists and it's in the mapping, use its ISO code
        if (
          typeof data.nationality === "string" &&
          data.nationality in countryCodeAndCurrency
        ) {
          return countryNameToCodeMap.get(data.nationality) || "-";
        }
        // Special case handling for common values
        if (data.nationality === "Singapore") return "SG";
        if (data.nationality === "Malaysia") return "MY";
      }
      return "-"; // Default fallback for individuals
    }

    // For organizations/institutions
    return "MY"; // Default fallback for organizations
  })();
  const identificationType = isOrgRoute ? "passport" : "national_identity";
  const identificationNumber = isOrgRoute
    ? "A56440609"
    : (userData?.regtankRequest !== undefined &&
        userData?.regtankRequest.length > 0 &&
        userData?.regtankRequest?.[0].ocrResults.idNumber) ||
      "-";
  const issueDate = isOrgRoute ? "18-07-2022" : dateOfBirth;
  const expiryDate = isOrgRoute ? "24-10-2027" : "-";

  //company
  const companyName = isOrgRoute ? data?.companyName || "-" : "-";
  const registrationNumber = data?.companyRegistrationNo || "-";
  const businessType = mapIndustryToBusinessType(data?.industry) || "-";
  const incorporationDate = data?.companyStartDate || "-";
  const displayIncorporationDate =
    convertDate(String(data?.companyStartDate), "DD-MM-YYYY") || "-";
  const city = "-";
  const state = "-";
  const countryOfDomicile = data?.countryISOCode || "-";
  const countryOfIncorporation = (() => {
    if (data?.countryOfIncorporation) {
      // If countryOfIncorporation exists and it's in the mapping, use its ISO code
      if (
        typeof data.countryOfIncorporation === "string" &&
        data.countryOfIncorporation in countryCodeAndCurrency
      ) {
        return countryNameToCodeMap.get(data.countryOfIncorporation) || "-";
      }
      // Special case handling for common values
      if (data.countryOfIncorporation === "Singapore") return "SG";
      if (data.countryOfIncorporation === "Malaysia") return "MY";
    }

    return "-"; // Default fallback
  })();
  const customerBusinessWebsite = data?.website || "-";
  const customerBusinessDescription =
    userData?.entityType === "institution" ? "investor" : "e-commerce merchant";
  const entityType = mapEntityType(data?.legalStructure) || "-";
  const ownershipStructureLayers = "1";
  const countryOfOperation = (() => {
    if (countryOfDomicile) {
      // Check if countryOfDomicile is already an ISO code (2 characters)
      if (countryOfDomicile.length === 2) {
        return countryOfDomicile;
      }

      // Try to get the ISO code by looking up the country name
      if (countryOfDomicile in countryCodeAndCurrency) {
        return countryNameToCodeMap.get(countryOfDomicile) || "-";
      }

      // Special case handling for common values
      if (countryOfDomicile === "Singapore") return "SG";
      if (countryOfDomicile === "Malaysia") return "MY";
    }

    return "-"; // Default fallback
  })();

  //Currency Code Mapping
  const currencyCode = mapCountryToCurrencyCode(data?.countryOfIncorporation);
  const currencyCodeForDomicile = mapCountryToCurrencyCode(
    codeToCountryNameMap.get(countryOfDomicile)
  );

  const paymentModes = "cash_direct_debit_or_credit";
  const onboardingMode = "face_to_face";
  const productServiceComplexity = "simple";
  const companyAddress = data?.legalEntityAddress || "-";
  const companyPostalCode = data?.postalCode || "-";
  const isPermanentPlaceOfBusiness = "yes";
  const siteVisitPerformedAtAddress = "perform virtually";
  const isPremisesInLineWithBusiness = "yes";
  const isHigherRiskEntityType =
    userData?.entityType === "institution" ? "no" : "yes";
  const higherRiskEntityType =
    userData?.entityType === "institution" ? "-" : "e_commerce_platform";
  const productUsage =
    "inbound_cross_border_or_collections, outbound_cross_border";
  const purposeOfAccountOpening =
    userData?.entityType === "institution"
      ? "investment"
      : "payment and collection";
  const isMakingPaymentsToIndividuals = "no";
  const makingPaymentsToIndividualsDescription = "-";
  const isMakingThirdPartyPayments = "no";
  const sourceOfFunds = "first_party_only";

  const countryOfIncorporationName =
    codeToCountryNameMap.get(countryOfIncorporation) || "-";
  const countryOfDomicileName =
    codeToCountryNameMap.get(countryOfDomicile) || "-";

  const primaryTransactingCountriesInbound = deduplicateCountries(
    userData?.entityType === "institution"
      ? `${countryOfIncorporationName},${countryOfDomicileName},Singapore`
      : countryOfDomicileName
  );
  const primaryTransactingCountriesOutbound = deduplicateCountries(
    userData?.entityType === "institution"
      ? `${countryOfIncorporationName},${countryOfDomicileName},Singapore`
      : `${countryOfDomicileName},Singapore`
  );
  const topCounterPartiesInbound =
    userData?.entityType === "institution"
      ? "Funded Here Pte. Ltd."
      : "e-commerce platform";
  const topCounterPartiesOutbound = "Funded Here Pte. Ltd.";
  const anticipatedVolumeMonthlyTransactionsCountInbound = "20";
  const anticipatedVolumeMonthlyTransactionsCountOutbound =
    userData?.entityType === "institution" ? "10" : "50";
  const anticipatedValueMonthlyTransactionsInbound =
    userData?.entityType === "institution"
      ? data?.investmentPreferences?.investmentSize || "-"
      : userData?.orgRole?.[0]?.creditLimit || "-";
  const anticipatedValueMonthlyTransactionsOutbound =
    userData?.entityType === "institution"
      ? data?.investmentPreferences?.investmentSize || "-"
      : userData?.orgRole?.[0]?.creditLimit || "-";

  const currencyPairsInboundSetOrg = new Set([`SGD${currencyCode}`, "SGDSGD"]);
  const currencyPairsInbound =
    userData?.entityType === "institution"
      ? Array.from(currencyPairsInboundSetOrg).join(", ")
      : `${currencyCodeForDomicile}${currencyCodeForDomicile}`;

  const currencyPairsOutboundSetOrg = new Set([`SGD${currencyCode}`, "SGDSGD"]);
  const currencyPairsOutboundSetInd = new Set([
    `${currencyCodeForDomicile}${currencyCodeForDomicile}`,
    `SGD${currencyCodeForDomicile}`,
  ]);
  const currencyPairsOutbound =
    userData?.entityType === "institution"
      ? Array.from(currencyPairsOutboundSetOrg).join(", ")
      : Array.from(currencyPairsOutboundSetInd).join(", ");

  const token = useSelector(
    (state: RootState) =>
      state.auth?.token ||
      ((state as any)._persist && (state as any)._persist.rehydrated
        ? (state as any).auth?.token
        : undefined)
  );

  const toggleExcludeDocument = (path: string, fileType: FileEnum) => {
    if (excludedFiles.includes(path)) {
      // If already excluded, restore it
      setExcludedFiles((prev) => prev.filter((p) => p !== path));
      //toast.success("Document restored.");
    } else {
      // Mark as excluded
      setExcludedFiles((prev) => [...prev, path]);
      //toast.success("Document marked as excluded from upload.");
    }
  };

  const toggleExcludePassportPhoto = (
    userId: string,
    pathFront: string,
    pathBack: string,
    isLocal: boolean = false
  ) => {
    const uniqueIdentifierFront = isLocal
      ? getLocalPhotoIdentifier(userId)
      : `user_${userId}_photo_${pathFront}`;
    const uniqueIdentifierBack = isLocal
      ? getLocalPhotoIdentifier(userId)
      : `user_${userId}_photo_${pathBack}`;
    if (
      excludedFiles.includes(uniqueIdentifierFront) &&
      excludedFiles.includes(uniqueIdentifierBack)
    ) {
      // If already excluded, restore it
      setExcludedFiles((prev) =>
        prev.filter((p) => p !== uniqueIdentifierFront)
      );
      setExcludedFiles((prev) =>
        prev.filter((p) => p !== uniqueIdentifierBack)
      );
    } else {
      // Mark as excluded
      setExcludedFiles((prev) => [...prev, uniqueIdentifierFront]);
      setExcludedFiles((prev) => [...prev, uniqueIdentifierBack]);
    }
  };

  const removeLocalPassportPhoto = (userId: string, fileIndex: number) => {
    setLocalPassportPhotos((prev) => {
      const currentFiles = prev[userId] || [];
      // Revoke the preview URL to free memory
      if (currentFiles[fileIndex]?.previewUrl) {
        URL.revokeObjectURL(currentFiles[fileIndex].previewUrl);
      }
      const updatedFiles = currentFiles.filter((_, index) => index !== fileIndex);
      if (updatedFiles.length === 0) {
        const newState = { ...prev };
        delete newState[userId];
        return newState;
      }
      return {
        ...prev,
        [userId]: updatedFiles,
      };
    });
  };

  const downloadDocument = (path: string, fileName: string) => {
    useGetDocumentMutaiton.mutate(
      { token, path },
      {
        onSuccess: (data: Blob) => {
          downloadFile(data, fileName, FileType.PDF);
        },
        onError: (e) => {
          toast.error((e as Error).message);
        },
      }
    );
  };

  const performUpload = async () => {
    setIsUploading(true);
    setUploadError(null);
    if (uploadPartialSuccess) {
      await documentUploadWallex();
    } else {
      await wallexUpload();
    }
  };

  // Update UI state after successful upload
  const handleUploadSuccess = () => {
    setIsUploading(false);
    setIsCompleted(true);
    setHasBeenSentToWallex(true);
    setUploadPartialSuccess(false);
  };

  // Refresh data from server after upload
  const refreshDataFromServer = async () => {
    if (!userId) return;

    try {
      const response = await checkWallexStatus(userId, token);

      if (Array.isArray(response.uploadedDocuments)) {
        setUploadedFiles(response.uploadedDocuments);
      }

      if (response.passportPhotos) {
        setWallexPassportPhotos(response.passportPhotos);
      }

      if (response.documentTimestamps) {
        updateLastTimestamp(response.documentTimestamps);
      }

      if (response.screeningStatus) {
        setScreeningStatus(response.screeningStatus);
      }
    } catch (error) {
      console.error("Error refreshing data after upload:", error);
    }
  };

  // Update timestamp from response
  const updateLastTimestamp = (timestamps: Record<string, string>) => {
    const timestampValues = Object.values(timestamps) as string[];
    if (timestampValues.length > 0) {
      const mostRecentTimestamp = new Date(
        Math.max(...timestampValues.map((ts) => new Date(ts).getTime()))
      );
      setLastUploadTimestamp(mostRecentTimestamp.toISOString());
    }
  };

  // Handle upload errors with appropriate state updates
  const handleUploadError = (error: any) => {
    if (error?.response?.data?.failedDocuments?.length > 0) {
      setFailedDocuments(error.response.data.failedDocuments);
      processSuccessfulUploads(error?.response?.data?.results);
      setUploadPartialSuccess(true);
      setHasBeenSentToWallex(false);
      refreshPassportPhotos();
    }

    setUploadError(error);
    setIsUploading(false);
    console.error("Document upload failed:", error);
  };

  // Process partial success results
  const processSuccessfulUploads = (results: any) => {
    if (!results) return;

    const successfulFiles = results
      .filter(
        (r: { status: string; fileName: string }) => r.status === "success"
      )
      .map((r: { status: string; fileName: string }) => r.fileName);

    if (successfulFiles.length > 0) {
      setUploadedFiles((prevFiles) => {
        const uniqueFiles = new Set([...prevFiles, ...successfulFiles]);
        return Array.from(uniqueFiles);
      });
    }
  };

  // Refresh passport photos after partial failure
  const refreshPassportPhotos = async () => {
    if (!userId) return;

    try {
      const response = await checkWallexStatus(userId, token);
      if (response && response.passportPhotos) {
        setWallexPassportPhotos(response.passportPhotos);
      }
    } catch (error) {
      console.error("Error refreshing national identity photos:", error);
    }
  };

  // Function to upload user/company information and documents to Wallex
  const wallexUpload = async () => {
    try {
      const payloadData = {
        // User Sign Up
        userIdFH: String(userId),
        accountType: isIndividualRoute ? "individual" : "company",
        email: email,
        firstName: String(firstName),
        lastName: String(lastName),
        countryCode: countryCode,
        companyName: companyName,

        // User Detail Update
        gender: String(gender),
        mobileCountryCode: String(mobileCountryCode),
        mobileNumber: Number(mobileNumber),
        employmentStatus: String(employmentStatus),
        employmentIndustry: String(employmentIndustry),
        employmentPosition: String(employmentPosition),
        dateOfBirth: String(dateOfBirth),
        countryOfBirth: String(countryOfBirth),
        residentialAddress: String(address),
        postalCode: String(postalCode),
        nationality: String(nationality),
        identificationType: identificationType,
        identificationNumber: identificationNumber,
        issueDate: issueDate,
        expiryDate: expiryDate,

        //Update Company
        registrationNumber: registrationNumber,
        businessType: businessType,
        incorporationDate: incorporationDate,
        city: city,
        state: state,
        companyAddress: String(companyAddress),
        companyPostalCode: String(companyPostalCode),

        // Customer Due Diligence
        customerBusinessWebsite: customerBusinessWebsite,
        customerBusinessDescription: customerBusinessDescription,
        entityType: entityType,
        ownershipStructureLayers: ownershipStructureLayers,
        countryOfIncorporation: countryOfIncorporation,
        countryOfOperations: countryOfOperation,
        paymentModes: paymentModes,
        onboardingMode: onboardingMode,
        productServiceComplexity: productServiceComplexity,
        isPermanentPlaceOfBusiness: isPermanentPlaceOfBusiness,
        siteVisitPerformedAtAddress: siteVisitPerformedAtAddress,
        isPremisesInLineWithBusiness: isPremisesInLineWithBusiness,
        isHigherRiskEntityType: isHigherRiskEntityType,
        higherRiskEntityType: higherRiskEntityType,
        productUsage: productUsage,
        purposeOfAccountOpening: purposeOfAccountOpening,
        isMakingPaymentsToIndividuals: isMakingPaymentsToIndividuals,
        makingPaymentsToIndividualsDescription:
          makingPaymentsToIndividualsDescription,
        isMakingThirdPartyPayments: isMakingThirdPartyPayments,
        sourceOfFunds: sourceOfFunds,
        primaryTransactingCountriesInbound: primaryTransactingCountriesInbound,
        primaryTransactingCountriesOutbound:
          primaryTransactingCountriesOutbound,
        topCounterPartiesInbound: topCounterPartiesInbound,
        topCounterPartiesOutbound: topCounterPartiesOutbound,
        anticipatedVolumeMonthlyTransactionsCountInbound: parseInt(
          anticipatedVolumeMonthlyTransactionsCountInbound
        ),
        anticipatedVolumeMonthlyTransactionsCountOutbound: parseInt(
          anticipatedVolumeMonthlyTransactionsCountOutbound
        ),
        anticipatedValueMonthlyTransactionsInbound: parseInt(
          anticipatedValueMonthlyTransactionsInbound?.toString()
        ),
        anticipatedValueMonthlyTransactionsOutbound: parseInt(
          anticipatedValueMonthlyTransactionsOutbound?.toString()
        ),
        currencyPairsInbound: currencyPairsInbound,
        currencyPairsOutbound: currencyPairsOutbound,

        // Excluded Files
        excludedFiles: excludedFiles,
      };

      await wallexInfoUpload(payloadData, token);

      // Call document upload function
      await documentUploadWallex();

      // If we get here, everything was successful
      setHasBeenSentToWallex(true);
      setUploadPartialSuccess(false);
      setFailedDocuments([]);
    } catch (error: any) {
      // Check if this is a document upload error with failed documents
      if (error?.response?.data?.failedDocuments?.length > 0) {
        // Store the failed documents
        setFailedDocuments(error.response.data.failedDocuments);

        // Mark as partial success
        setUploadPartialSuccess(true);
        setHasBeenSentToWallex(false);
      }

      setUploadError(error);
      setIsUploading(false);
      console.error("Document upload failed:", error);
      throw error;
    }
  };

  // Function to upload documents only to Wallex
  const documentUploadWallex = async () => {
    try {
      const uploadedFileNames: string[] = [];
      const documentsToSubmit = JSON.parse(JSON.stringify(documentPaths));
      const documentsArray = [];

      // Process each document category
      for (const category of Object.keys(documentsToSubmit)) {
        // Filter excluded files
        const filesToUpload = documentsToSubmit[category].filter(
          (path: string) => !excludedFiles.includes(path)
        );

        // Add each document to the array
        for (const filePath of filesToUpload) {
          const fileName = getNameFromPath(filePath);
          const fileNameOnly = fileName.split("\\").pop() || fileName;
          documentsArray.push({
            fileName: String(fileName),
            documentType: String(
              mapCategoryToDocumentType(category, isIndividualRoute)
            ),
            contentType: "application/pdf", // Default content type for documents
            path: filePath,
            userId: userId,
          });

          // Add to our tracking array
          uploadedFileNames.push(fileNameOnly);
        }
      }

      // Add passport photos that aren't excluded
      if (user?.length) {
        let usersToProcess: UserData[] = [];
        // Filter to only include Directors
        if (isOrgRoute) {
          usersToProcess = user.filter((currentUser) => {
            // Check if jobTitle is Director
            const hasDirectorJobTitle = currentUser?.jobTitle === "Director";

            // Check if email found in boardOfDirectors
            const userEmail = currentUser?.email;

            const boardEmails: string[] = [];
            if (
              data?.boardOfDirectors &&
              Array.isArray(data.boardOfDirectors)
            ) {
              // Extract all valid emails from all board of directors
              data.boardOfDirectors.forEach((director) => {
                if (director?.email) {
                  boardEmails.push(director.email.toLowerCase().trim());
                }
              });
            }

            // Check if email is in boardOfDirectors
            const isInBoardOfDirectors = boardEmails.includes(userEmail);

            // Only keep Director users that are in the Board of Directors
            return hasDirectorJobTitle && isInBoardOfDirectors;
          });
        } else {
          usersToProcess = user;
        }

        usersToProcess.forEach((currentUser) => {
          const userId = currentUser.id.toString();
          const uniqueIdentifier = `user_${userId}_photo_${currentUser.didPassportPhoto}`;
          const localPhotoDataArray = localPassportPhotos[userId];

          // First: include locally uploaded photos if available and not excluded
          if (localPhotoDataArray && localPhotoDataArray.length > 0) {
            localPhotoDataArray.forEach((localPhotoData, index) => {
              // Create filename using the local file's name or a default name with the user ID
              const fileBaseName =
                localPhotoData.file.name.split(".")[0] || `passport_${index + 1}`;
              const fileExtension = localPhotoData.file.name.split(".").pop() || "jpg";
              const passportFileName = `${fileBaseName}.${fileExtension}`;
              const base64String = localPhotoData.binaryData // Create a base64 representation of the binary data
                ? btoa(
                    new Uint8Array(
                      localPhotoData.binaryData as ArrayBuffer
                    ).reduce((data, byte) => data + String.fromCharCode(byte), "")
                  )
                : "";

              documentsArray.push({
                fileName: passportFileName,
                documentType: "passport",
                contentType: localPhotoData.file.type || "image/jpeg",
                fileBuffer: base64String,
                userId: userId,
                passportUserId: userData?.id,
              });
            });
          }
          if (regtankDocumentPhoto.length > 0) {
            const matchRegtank = regtankDocumentPhoto.find(
              (x) => x.userId === currentUser.id
            );
            // Second priority: use existing photo if not excluded
            if (
              matchRegtank?.frontDocumentPhoto &&
              matchRegtank.backDocumentPhoto &&
              !excludedFiles.includes(uniqueIdentifier)
            ) {
              let base64DataFront = matchRegtank.frontDocumentPhoto;
              let fileTypeFront = "";
              if (base64DataFront.startsWith("data:")) {
                // Extract just the base64 part after the comma
                base64DataFront = base64DataFront.split(",")[1];
                fileTypeFront = matchRegtank.frontDocumentPhoto
                  .split(";")[0]
                  .split("/")[1];
              }
              let base64DataBack = matchRegtank.backDocumentPhoto;
              let fileTypeBack = "";
              if (base64DataBack.startsWith("data:")) {
                // Extract just the base64 part after the comma
                base64DataBack = base64DataBack.split(",")[1];
                fileTypeBack = matchRegtank.backDocumentPhoto
                  .split(";")[0]
                  .split("/")[1];
              }

              documentsArray.push({
                fileName: `National_Identity_Front.${fileTypeFront}`,
                documentType: "national_identity",
                contentType: `image/${fileTypeFront}`,
                fileBuffer: base64DataFront,
                userId: userId,
                passportUserId: userData?.id,
              });
              documentsArray.push({
                fileName: `National_Identity_Back.${fileTypeBack}`,
                documentType: "national_identity",
                contentType: `image/${fileTypeBack}`,
                fileBuffer: base64DataBack,
                userId: userId,
                passportUserId: userData?.id,
              });
            }
          }
        });
      }
      // API call for document upload only
      if (documentsArray.length > 0) {
        await uploadWallexDocuments(documentsArray, token);
        setUploadedFiles(uploadedFileNames);
      }
    } catch (error) {
      console.error("Document upload error:", error);
      throw error;
    }
  };

  return (
    <div>
      {/* Wallex Onboarding Status - Shows when hasBeenSentToWallex is true OR screeningStatus is "documents_need_resubmission" */}
      {(hasBeenSentToWallex ||
        screeningStatus === "documents_need_resubmission" ||
        screeningStatus === "pending_docs") && (
        <div
          style={{
            marginTop: "10px",
            marginBottom: "-10px",
            display: "flex",
            justifyContent: "center", // Center the status box
            width: "100%", // Take full width to allow centering
          }}
        >
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "10px 15px",
              border: "1px solid #dee2e6",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Text weight={500} size="md">
              Wallex Onboarding Status:{" "}
              <Text
                style={{
                  color:
                    screeningStatus === "approved"
                      ? "#2e7d32"
                      : ["pending_docs", "pending_approval"].includes(
                          screeningStatus ?? ""
                        )
                      ? "#ff9800"
                      : ["documents_need_resubmission"].includes(
                          screeningStatus ?? ""
                        )
                      ? "#f57c00"
                      : ["rejected", "suspended"].includes(
                          screeningStatus ?? ""
                        )
                      ? "#d32f2f"
                      : ["inactive", "dormant"].includes(screeningStatus ?? "")
                      ? "#757575"
                      : "#757575",
                }}
                span
                weight={600}
              >
                {screeningStatus === "approved"
                  ? "Approved"
                  : screeningStatus === "pending_docs"
                  ? "Pending Documents"
                  : screeningStatus === "pending_approval"
                  ? "Pending Approval"
                  : screeningStatus === "rejected"
                  ? "Rejected"
                  : screeningStatus === "documents_need_resubmission"
                  ? "Documents need resubmission"
                  : screeningStatus === "inactive"
                  ? "Inactive"
                  : screeningStatus === "suspended"
                  ? "Suspended"
                  : screeningStatus === "dormant"
                  ? "Dormant"
                  : "Pending"}
              </Text>
            </Text>

            {/* Remarks section */}
            {(screeningStatus === "rejected" ||
              screeningStatus === "documents_need_resubmission" ||
              screeningStatus === "pending_docs") &&
              screeningRemarks && (
                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "14px",
                    color: "#d32f2f",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <Text weight={500} color="black">
                    Remarks:{" "}
                    <span style={{ color: "#d32f2f" }}>{screeningRemarks}</span>
                  </Text>
                </div>
              )}
          </div>
        </div>
      )}
      <div className={classes.sectionHeader}>
        <b>
          {hasBeenSentToWallex
            ? "Onboarding Information Sent to Wallex"
            : "Onboarding Information to Wallex"}
        </b>
      </div>
      <div className={classes.parentContainer}>
        <div className={classes.valueContainer}>
          <div className={classes.companyInfoContainer}>
            <Forms.UserSignUpDetails
              accountType={isIndividualRoute ? "individual" : "company"}
              email={email}
              firstName={firstName}
              lastName={lastName}
              companyName={companyName}
              countryCode={countryCode}
            />

            <Forms.UserDetails
              firstName={firstName}
              lastName={lastName}
              gender={gender}
              mobileCountryCode={mobileCountryCode}
              mobileNumber={mobileNumber}
              employmentStatus={employmentStatus}
              employmentIndustry={employmentIndustry}
              employmentPosition={employmentPosition}
              dateOfBirth={dateOfBirth}
              countryOfBirth={countryOfBirth}
              residentialAddress={address}
              postalCode={postalCode}
              countryCode={countryCode}
              nationality={nationality}
              identificationType={identificationType}
              identificationNumber={identificationNumber || "-"}
              issueDate={issueDate}
              expiryDate={expiryDate}
            />

            {isOrgRoute && (
              <>
                <Forms.CompanyDetails
                  companyName={companyName}
                  businessType={businessType}
                  registrationNumber={registrationNumber}
                  incorporationDate={displayIncorporationDate}
                  companyAddress={companyAddress}
                  companyPostalCode={companyPostalCode}
                  city={city}
                  state={state}
                  countryOfIncorporation={countryOfIncorporation || "-"}
                  countryOfOperation={countryOfDomicile || "-"}
                />
                <Forms.CustomerDueDiligence
                  customerBusinessWebsite={customerBusinessWebsite}
                  customerBusinessDescription={customerBusinessDescription}
                  entityType={entityType}
                  ownershipStructureLayers={ownershipStructureLayers}
                  countryOfIncorporation={countryOfIncorporation || "-"}
                  countryOfOperation={countryOfDomicile || "-"}
                  paymentModes={paymentModes}
                  onboardingMode={onboardingMode}
                  productServiceComplexity={productServiceComplexity}
                  companyAddress={companyAddress}
                  isPermanentPlaceOfBusiness={isPermanentPlaceOfBusiness}
                  siteVisitPerformedAtAddress={siteVisitPerformedAtAddress}
                  isPremisesInLineWithBusiness={isPremisesInLineWithBusiness}
                  isHigherRiskEntityType={isHigherRiskEntityType}
                  higherRiskEntityType={higherRiskEntityType}
                  productUsage={productUsage}
                  purposeOfAccountOpening={purposeOfAccountOpening}
                  isMakingPaymentsToIndividuals={isMakingPaymentsToIndividuals}
                  makingPaymentsToIndividualsDescription={
                    makingPaymentsToIndividualsDescription
                  }
                  isMakingThirdPartyPayments={isMakingThirdPartyPayments}
                  sourceOfFunds={sourceOfFunds}
                  primaryTransactingCountriesInbound={
                    primaryTransactingCountriesInbound
                  }
                  primaryTransactingCountriesOutbound={
                    primaryTransactingCountriesOutbound
                  }
                  topCounterPartiesInbound={topCounterPartiesInbound}
                  topCounterPartiesOutbound={topCounterPartiesOutbound}
                  anticipatedVolumeMonthlyTransactionsCountInbound={
                    anticipatedVolumeMonthlyTransactionsCountInbound
                  }
                  anticipatedVolumeMonthlyTransactionsCountOutbound={
                    anticipatedVolumeMonthlyTransactionsCountOutbound
                  }
                  anticipatedValueMonthlyTransactionsInbound={
                    anticipatedValueMonthlyTransactionsInbound
                  }
                  anticipatedValueMonthlyTransactionsOutbound={
                    anticipatedValueMonthlyTransactionsOutbound
                  }
                  currencyPairsInbound={currencyPairsInbound}
                  currencyPairsOutbound={currencyPairsOutbound}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className={classes.sectionHeader}>
        <Divider my="md" className={classes.divider} />
        <b>
          {hasBeenSentToWallex
            ? "Onboarding Documents Sent to Wallex"
            : "Onboarding Documents to Wallex"}
        </b>
      </div>
      <div className={classes.valueContainer}>
        <div className={classes.docContainer}>
          {/* Render documents based on centralized configuration */}
          {documentConfigs
            .filter(config => {
              // Only show documents that are relevant for this context
              // InfoDocWallex currently shows: businessProfile, shareHoldersDirectorsRegisters, proofOfAddress
              const allowedFields = [
                'businessProfile',
                'shareHoldersDirectorsRegisters',
                'proofOfAddress'
              ];
              return allowedFields.includes(config.field);
            })
            .map(config => {
              const documents = documentPaths[config.field] || [];
              return (
                <DocumentRenderer
                  key={config.field}
                  documents={documents}
                  header={getDocumentHeader(config, data)}
                  fileType={config.fileType}
                  hasBeenSentToWallex={hasBeenSentToWallex}
                  uploadedFiles={uploadedFiles}
                  excludedFiles={excludedFiles}
                  downloadDocument={downloadDocument}
                  toggleExcludeDocument={toggleExcludeDocument}
                  failedDocuments={failedDocuments}
                  uploadPartialSuccess={uploadPartialSuccess}
                  classes={classes}
                />
              );
            })}
          <Text className={classes.header}>National Identity Document</Text>
          {/* First check if there are any Director users */}
          {(() => {
            // Get all directors
            const directors = user?.filter(
              (u) =>
                u?.jobTitle === "Director" ||
                u?.orgRole?.some(
                  (role) =>
                    (typeof role.role === "object"
                      ? role.role.name
                      : role.role) === "Director"
                )
            );

            if (isOrgRoute) {
              // If there are directors but no photos after applying all filters
              const directorsWithPhotos = directors?.filter((user) => {
                // Your existing filter logic for photos
                if (!hasBeenSentToWallex) return true;

                const currentUserId = user.id.toString();
                const hasWallexPhoto = Object.values(wallexPassportPhotos).some(
                  (photo) => photo.ownerId === currentUserId
                );

                if (hasWallexPhoto) return true;
                const didPassportPhotoName =
                  user?.didPassportPhoto?.split("/")?.pop() || "";
                const isExistingPhotoInDatabase = uploadedFiles.some(
                  (filename) =>
                    didPassportPhotoName &&
                    filename.includes(didPassportPhotoName)
                );

                const localPhotos = localPassportPhotos[user.id] || [];
                const isLocalPhotoInDatabase =
                  localPhotos.length > 0 &&
                  localPhotos.some((photo) =>
                    uploadedFiles.some(
                      (filename) => filename === photo.file.name
                    )
                  );

                return isExistingPhotoInDatabase || isLocalPhotoInDatabase;
              });

              if (
                hasBeenSentToWallex &&
                Object.keys(wallexPassportPhotos).length === 0
              ) {
                return (
                  <div>
                    <Text
                      color="dimmed"
                      italic
                      align="center"
                      py="md"
                      size="lg"
                    >
                      No National Identity Document has been sent.
                    </Text>
                  </div>
                );
              }
            }
            // Otherwise return null and let the regular card rendering continue
            // return null;
          })()}

          <div className={classes.docContainer}>
            <Flex gap="md" wrap="wrap">
              {(() => {
                // First filter the users to get only directors
                const filteredUsers = user?.filter((user) => {
                  // For individual routes, don't filter by role
                  if (isIndividualRoute) {
                    return true;
                  }

                  // Check if jobTitle is Director
                  const hasDirectorJobTitle = user?.jobTitle === "Director";

                  // Check if email found in boardOfDirectors
                  const userEmail = user?.email;

                  const boardEmails: string[] = [];
                  if (
                    data?.boardOfDirectors &&
                    Array.isArray(data.boardOfDirectors)
                  ) {
                    // Extract all valid emails from all board of directors
                    data.boardOfDirectors.forEach((director) => {
                      if (director?.email) {
                        boardEmails.push(director.email.toLowerCase().trim());
                      }
                    });
                  }

                  // Check if email is in boardOfDirectors - use direct .some() method with a clean comparison
                  const isInBoardOfDirectors = boardEmails.includes(userEmail);

                  // Only keep Director users that are in the Board of Directors
                  return hasDirectorJobTitle && isInBoardOfDirectors;
                });

                // Check if we have any directors after filtering
                if (
                  isOrgRoute &&
                  (!filteredUsers || filteredUsers.length === 0) &&
                  !hasBeenSentToWallex
                ) {
                  return (
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <Text
                        color="dimmed"
                        italic
                        align="center"
                        py="md"
                        size="lg"
                      >
                        No National Identity Document available
                      </Text>
                    </div>
                  );
                }

                // If we have directors, then render the cards for them
                return filteredUsers?.map((user, index) => {
                  const identityPhotoFrontRegtank = regtankDocumentPhoto.find(
                    (x) => x.requestId === user.regtankRequest?.[0].requestId
                  )?.frontDocumentPhoto;
                  const identityPhotoBackRegtank = regtankDocumentPhoto.find(
                    (x) => x.requestId === user.regtankRequest?.[0].requestId
                  )?.backDocumentPhoto;
                  return (
                    <Card
                      key={user.id}
                      shadow="sm"
                      padding="lg"
                      radius="md"
                      withBorder
                      className={classes.personCard}
                      style={{ marginBottom: "15px" }}
                    >
                      <Card.Section withBorder inheritPadding py="xs" mb="xs">
                        <Group position="apart">
                          <Text weight={500}>
                            {user?.firstName + " " + user?.lastName}
                          </Text>
                          <Text weight={200}>{user?.jobTitle || " "}</Text>
                        </Group>
                      </Card.Section>
                      <LoadingOverlay visible={passportPhotoIsLoading} />
                      <div className={classes.photoDisplay}>
                        {hasBeenSentToWallex ||
                        Object.values(wallexPassportPhotos).some(
                          (photo) =>
                            photo.ownerId === user.id.toString() ||
                            ("passportUserId" in photo &&
                              (photo as any).passportUserId ===
                                user.id.toString())
                        ) ? (
                          <div style={{ position: "relative" }}>
                            {(() => {
                              // Get ONLY photos that exactly match this user's ID
                              const photo = Object.values(
                                wallexPassportPhotos
                              ).filter((photo) => {
                                const currentUserId = user.id.toString();

                                // Check if this is a direct match via ownerId
                                const directMatch =
                                  photo.ownerId === currentUserId;

                                //Check if there's a match via passportUserId (which may not exist on all photos)
                                const hasPassportUserId =
                                  "passportUserId" in photo;

                                const passportUserIdMatch =
                                  hasPassportUserId &&
                                  (photo as any).passportUserId ===
                                    currentUserId;

                                // Return true if any of these conditions match
                                return directMatch || passportUserIdMatch;
                              });

                              if (photo.length > 0) {
                                return (
                                  <div>
                                    {photo.map((photo, photoIndex) => (
                                      <div key={photoIndex}>
                                        <img
                                          className={classes.photo}
                                          src={photo.data}
                                          alt="Passport"
                                          // alt={`${user.firstName}'s Passport Photo`}
                                        />

                                        <div
                                          style={{
                                            marginTop: "8px",
                                            padding: "3px 8px",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            backgroundColor: "#e6f7ee",
                                            border: "1px solid #a8e6c1",
                                            color: "#2e7d32",
                                            display: "inline-block",
                                            position: "relative",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            textAlign: "center",
                                          }}
                                        >
                                          Sent to Wallex
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                );
                              } else {
                                return (
                                  <Text
                                    color="dimmed"
                                    italic
                                    align="center"
                                    py="md"
                                  >
                                    No National Identity Document has been sent.
                                  </Text>
                                );
                              }
                            })()}
                          </div>
                        ) : (identityPhotoBackRegtank &&
                            identityPhotoBackRegtank) ||
                          localPassportPhotos[user.id] ? (
                          <>
                            {/* Show Luminos stored passport photo */}
                            {identityPhotoBackRegtank &&
                              identityPhotoBackRegtank &&
                              !passportPhotoIsLoading && (
                                <div
                                  style={{
                                    position: "relative",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "5px",
                                      right: "5px",
                                      zIndex: 5,
                                    }}
                                  >
                                    {/* Remove/Restore button - only show if there's an original photo */}
                                    {identityPhotoBackRegtank &&
                                      identityPhotoFrontRegtank && (
                                        <Button
                                          onClick={() =>
                                            identityPhotoBackRegtank &&
                                            toggleExcludePassportPhoto(
                                              user.id.toString(),
                                              identityPhotoFrontRegtank,
                                              identityPhotoBackRegtank
                                            )
                                          }
                                          variant={
                                            excludedFiles.includes(
                                              `user_${user.id}_photo_${identityPhotoFrontRegtank}` &&
                                                `user_${user.id}_photo_${identityPhotoBackRegtank}}`
                                            )
                                              ? "outline"
                                              : "filled"
                                          }
                                          color={
                                            excludedFiles.includes(
                                              `user_${user.id}_photo_${identityPhotoFrontRegtank}` &&
                                                `user_${user.id}_photo_${identityPhotoBackRegtank}}`
                                            )
                                              ? "green"
                                              : "red"
                                          }
                                          size="xs"
                                          compact
                                        >
                                          <Text>
                                            {excludedFiles.includes(
                                              `user_${user.id}_photo_${identityPhotoFrontRegtank}`
                                            )
                                              ? "Restore"
                                              : "Exclude"}
                                          </Text>
                                        </Button>
                                      )}
                                  </div>
                                  <img
                                    src={identityPhotoFrontRegtank}
                                    alt="Passport"
                                    className={classes.photo}
                                    style={
                                      excludedFiles.includes(
                                        `user_${user.id}_photo_${identityPhotoFrontRegtank}`
                                      )
                                        ? { opacity: "0.5" }
                                        : {}
                                    }
                                  />

                                  <img
                                    src={identityPhotoBackRegtank}
                                    alt="Passport"
                                    className={classes.photo}
                                    style={
                                      excludedFiles.includes(
                                        `user_${user.id}_photo_${identityPhotoBackRegtank}`
                                      )
                                        ? { opacity: "0.5" }
                                        : {}
                                    }
                                  />
                                  {/* Add EXCLUDED overlay for existing photos */}
                                  {excludedFiles.includes(
                                    `user_${user.id}_photo_${identityPhotoFrontRegtank}` &&
                                      `user_${user.id}_photo_${identityPhotoBackRegtank}`
                                  ) && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        backgroundColor: "rgba(255, 0, 0, 0.6)",
                                        color: "white",
                                        padding: "5px 10px",
                                        fontWeight: "bold",
                                        borderRadius: "4px",
                                        pointerEvents: "none",
                                      }}
                                    >
                                      EXCLUDED
                                    </div>
                                  )}
                                </div>
                              )}
                            {/* Show newly uploaded photos if available */}
                            {localPassportPhotos[user.id] &&
                              localPassportPhotos[user.id].length > 0 && (
                                <div
                                  style={{
                                    marginTop: user?.didPassportPhoto
                                      ? "10px"
                                      : "0",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "10px",
                                  }}
                                >
                                  {localPassportPhotos[user.id].map(
                                    (photoData, fileIndex) => (
                                      <div
                                        key={`${user.id}-${photoData.file.name}-${photoData.file.lastModified}`}
                                        style={{ position: "relative" }}
                                      >
                                        {photoData.file.type ===
                                        "application/pdf" ? (
                                          <div
                                            className={classes.photo}
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              backgroundColor: "#f5f5f5",
                                              border: "2px dashed #ccc",
                                            }}
                                          >
                                            <Text
                                              size="48px"
                                              style={{ marginBottom: "8px" }}
                                            >
                                              📄
                                            </Text>
                                            <Text align="center" weight={500}>
                                              PDF Document
                                            </Text>
                                            <Text
                                              size="xs"
                                              color="dimmed"
                                              align="center"
                                              style={{ marginTop: "4px" }}
                                            >
                                              {photoData.file.name}
                                            </Text>
                                          </div>
                                        ) : (
                                          <img
                                            src={photoData.previewUrl}
                                            alt={`Uploaded document ${fileIndex + 1}`}
                                            className={classes.photo}
                                          />
                                        )}

                                        {/* Remove button */}
                                        {(!hasBeenSentToWallex ||
                                          screeningStatus ===
                                            "documents_need_resubmission") && (
                                          <Button
                                            onClick={() =>
                                              removeLocalPassportPhoto(
                                                user.id.toString(),
                                                fileIndex
                                              )
                                            }
                                            variant="filled"
                                            color="red"
                                            size="xs"
                                            compact
                                            style={{
                                              position: "absolute",
                                              top: "5px",
                                              right: "5px",
                                            }}
                                          >
                                            Remove
                                          </Button>
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            {/* Buttons container - hide all buttons if already sent */}
                            {(!hasBeenSentToWallex ||
                              screeningStatus ===
                                "documents_need_resubmission") && (
                              <div
                                style={{
                                  marginTop: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "70%",
                                }}
                              >
                                {/* Upload button */}
                                <div>
                                  <input
                                    type="file"
                                    id={`file-upload-${user.id}`}
                                    accept="image/*,application/pdf"
                                    multiple
                                    onChange={(e) =>
                                      handlePassportPhotoUpload(
                                        user.id.toString(),
                                        e
                                      )
                                    }
                                    style={{ display: "none" }}
                                  />
                                  <Button
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          `file-upload-${user.id}`
                                        )
                                        ?.click()
                                    }
                                    variant="filled"
                                    color="blue"
                                    size="sm"
                                  >
                                    Upload
                                  </Button>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            {!hasBeenSentToWallex && (
                              <div>
                                <Text
                                  color="dimmed"
                                  italic
                                  align="center"
                                  py="md"
                                >
                                  No National Identity Document available
                                </Text>
                                <div
                                  style={{
                                    marginTop: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "70%",
                                  }}
                                >
                                  {/* Upload button */}
                                  <div>
                                    <input
                                      type="file"
                                      id={`file-upload-${user.id}`}
                                      accept="image/*,application/pdf"
                                      multiple
                                      onChange={(e) =>
                                        handlePassportPhotoUpload(
                                          user.id.toString(),
                                          e
                                        )
                                      }
                                      style={{ display: "none" }}
                                    />
                                    <Button
                                      onClick={() =>
                                        document
                                          .getElementById(
                                            `file-upload-${user.id}`
                                          )
                                          ?.click()
                                      }
                                      variant="filled"
                                      color="blue"
                                      size="sm"
                                    >
                                      Upload
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </Card>
                  );
                });
              })()}
            </Flex>
          </div>
          {/* Send button */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                backgroundColor: hasBeenSentToWallex
                  ? "#cccccc"
                  : uploadPartialSuccess
                  ? "#ff9800" // Orange for partial success
                  : "#007bff",
                color: hasBeenSentToWallex ? "#666666" : "white",
                width: "100px", // Fixed width in pixels instead of percentage
                minWidth: "150px", // Ensures the button doesn't shrink below this width
                border: "none",
                borderRadius: "8px",
                padding: "10px 0",
                boxShadow: hasBeenSentToWallex
                  ? "none"
                  : "0 4px 6px rgba(0,0,0,0.1)",
                transition: "transform 0.1s, box-shadow 0.1s",
                position: "relative",
                top: "0",
                cursor: hasBeenSentToWallex ? "default" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
              }}
              onClick={() => setIsConfirmModalOpen(true)}
              onMouseDown={(e) => {
                if (!hasBeenSentToWallex) {
                  e.currentTarget.style.transform = "translateY(3px)";
                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                }
              }}
              onMouseUp={(e) => {
                if (!hasBeenSentToWallex) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!hasBeenSentToWallex) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
                }
              }}
              disabled={hasBeenSentToWallex}
            >
              {hasBeenSentToWallex ? (
                <>
                  <IconCircleCheck
                    size={24}
                    style={{ marginRight: "8px", color: "#666666" }}
                  />
                  Sent to Wallex
                </>
              ) : uploadPartialSuccess ? (
                <>Resend</>
              ) : (
                <>Send</>
              )}
            </button>
          </div>
          {/* Timestamp display */}
          {hasBeenSentToWallex && lastUploadTimestamp && (
            <div
              style={{
                marginTop: "8px",
                fontSize: "13px",
                color: "#666666",
                fontStyle: "italic",
                textAlign: "center", // Added to center the text
                width: "100%", // Ensure the div takes full width for centering to work
              }}
            >
              Onboarding information and documents have been sent to Wallex on{" "}
              {formatLocalDate(lastUploadTimestamp)}
            </div>
          )}
        </div>
      </div>
      <Modal
        opened={isConfirmModalOpen}
        onClose={() => {
          if (!isUploading) {
            setIsConfirmModalOpen(false);
            setUploadError(null);
          }
        }}
        title={
          <b>
            {uploadError
              ? "Upload Failed to Wallex"
              : isCompleted
              ? "Submission Successful"
              : isUploading
              ? "Submitting to Wallex..."
              : "Confirm Submission to Wallex"}
          </b>
        }
        centered
        closeOnClickOutside={!isUploading}
        closeOnEscape={!isUploading}
      >
        {uploadError ? (
          // Error view - show this FIRST if there's an error
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ marginBottom: "15px", color: "red" }}>
              <i
                className="fas fa-exclamation-circle"
                style={{ fontSize: "24px" }}
              ></i>
            </div>
            <IconExclamationCircle color="red" />
            <p
              style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}
            >
              Upload Failed
            </p>
            <p style={{ fontSize: "14px", color: "#666" }}>
              Please contact the Tech team for assistance and provide a
              screenshot of this error message
            </p>
            <p style={{ marginBottom: "10px" }}>{uploadError.message}</p>
            <p style={{ marginBottom: "10px" }}>
              {/* Show the custom error message with Wallex Upload failed appended */}
              {uploadError.response?.data?.message ? (
                <>{uploadError.response?.data?.source}</>
              ) : (
                // Fallback to standard error message if the custom one isn't available
                uploadError?.message ||
                "An unknown error occurred during the upload process"
              )}
            </p>
            {/* Display detailed errors in a more readable format */}
            {uploadError?.response?.messages ||
              (uploadError && (
                <div
                  style={{
                    textAlign: "left",
                    marginTop: "10px",
                    padding: "10px",
                    backgroundColor: "#fff0f0",
                    border: "1px solid #ffcccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                  }}
                >
                  <strong>Error details:</strong>
                  <ul
                    style={{
                      marginTop: "5px",
                      paddingLeft: "20px",
                      padding: "10px",
                    }}
                  >
                    {typeof uploadError.response.data.errors === "object" &&
                    uploadError.response?.data?.failedDocuments ? (
                      Object.entries(uploadError.response.data.errors).map(
                        ([key, value]) => (
                          <li key={key}>
                            <strong>{key}:</strong>{" "}
                            {Array.isArray(value)
                              ? value.join(", ")
                              : String(value)}
                          </li>
                        )
                      )
                    ) : Array.isArray(uploadError.response?.data?.message) ? (
                      uploadError.response?.data?.message.map(
                        (msg: any, i: any) => <li key={i}>{msg}</li>
                      )
                    ) : (
                      <li>{uploadError.response?.data?.message}</li>
                    )}
                  </ul>
                </div>
              ))}
            {uploadError && uploadError.response?.data?.failedDocuments && (
              <div
                style={{
                  textAlign: "left",
                  border: "1px solid #ffcccc",
                  borderRadius: "4px",
                  padding: "10px",
                  backgroundColor: "#fff0f0",
                  marginBottom: "15px",
                }}
              >
                <p>
                  <strong>
                    Failed documents (
                    {uploadError.response.data.failedDocuments.length}):
                  </strong>
                </p>
                <div
                  style={{
                    maxHeight: "200px", // Limit the height
                    overflowY: "auto", // Enable vertical scrolling
                    paddingRight: "5px", // Add some padding for the scrollbar
                    marginBottom: "5px", // Add space at bottom
                  }}
                >
                  {Array.isArray(uploadError.response.data.failedDocuments) ? (
                    uploadError.response.data.failedDocuments.map(
                      (
                        doc: {
                          fileName?: string;
                          errorMessage?: string;
                          error?: string;
                          supportMessage?: string;
                        },
                        i: number
                      ) => (
                        <div
                          key={i}
                          style={{
                            margin: "8px 0",
                            padding: "5px 0",
                            borderBottom:
                              i <
                              uploadError.response.data.failedDocuments.length -
                                1
                                ? "1px solid #eee"
                                : "none",
                          }}
                        >
                          <div>
                            <strong>File:</strong>{" "}
                            {typeof doc.fileName === "string"
                              ? doc.fileName
                              : "[Unknown]"}
                          </div>
                          <div>
                            <strong>Error:</strong>
                            {""}
                            {doc.errorMessage ||
                              doc.error ||
                              "Failed to upload document(s)"}
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <p>No detailed error information available</p>
                  )}
                </div>
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginTop: "15px",
              }}
            >
              {uploadError.response?.data?.failedDocuments &&
              uploadError.response.data.failedDocuments.length > 0 ? (
                <>
                  <Button
                    variant="outline"
                    onClick={() => {
                      setIsConfirmModalOpen(false);
                      setUploadError(null);
                    }}
                  >
                    Close
                  </Button>
                </>
              ) : (
                // Only show Close button if it's not a document upload error
                <Button
                  variant="outline"
                  onClick={() => {
                    setIsConfirmModalOpen(false);
                    setUploadError(null);
                  }}
                >
                  Close
                </Button>
              )}
            </div>
          </div>
        ) : isUploading ? (
          // Loading view - show this second if uploading
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div className="spinner" style={{ marginBottom: "15px" }}>
              <Loader size="md" />
            </div>
            <p>Submitting onboarding information and documents to Wallex...</p>
          </div>
        ) : isCompleted ? (
          // Success view - new section
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ marginBottom: "15px", color: "green" }}>
              <i
                className="fas fa-check-circle"
                style={{ fontSize: "40px" }}
              ></i>
            </div>
            <IconCircleCheck color="green" />
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "green",
                marginBottom: "10px",
              }}
            >
              Submission Successful
            </p>
            <p>
              Onboarding information and documents have been successfully sent
              to Wallex.
            </p>
          </div>
        ) : (
          // Confirmation view - show this last if neither error nor uploading
          <>
            <p>
              The onboarding information and documents for{" "}
              {isOrgRoute ? companyName : `${firstName} ${lastName}`} will be
              sent to Wallex.
            </p>

            <div
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button
                variant="outline"
                color="gray"
                onClick={() => setIsConfirmModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                color="blue"
                onClick={async () => {
                  try {
                    // Perform the appropriate upload
                    await performUpload();

                    // Handle successful upload
                    await handleUploadSuccess();

                    // Refresh data from server
                    await refreshDataFromServer();
                  } catch (error: any) {
                    handleUploadError(error);
                  }
                }}
              >
                Confirm
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default InfoDocWallex;
